<template>
  <div class="ekstra">
    <h1>{{ $t('ekstra') }}</h1>
    <!-- {{ this.$store.getters.ekstras }} -->
    <!-- {{ this.$store.getters.bookingInProgress }} -->
    <!-- <p>Ekstras: {{this.$store.getters.ekstras}}</p> -->
    <!-- <pre>Rooms: {{ $store.getters.tb_rooms }}</pre> -->
    <!-- <p>detailedEkstras: {{ this.detailedEkstras }}</p> -->
    <!-- <p>detailedEkstrasOriginal: {{ this.detailedEkstrasOriginal }}</p> -->
    <!-- <p>detailedEkstras Axios store: {{ this.$store.getters.bookingInProgress.detailedEkstras }}</p> -->
    <!-- <p>child færdig med at skrive til vuex: {{ this.detailedEkstrasHasFinishedWritingToVuex }}</p> -->

    <!-- Vis 'loading' ikon mens API data loader... -->
    <img v-if="this.$store.getters.loading === true" src="@/assets/loading.svg" alt="">


    <div class="flex-container">
      <div v-for="ekstra in this.$store.getters.ekstras" v-bind:key="ekstra.id_rec">
        <!-- Der er 3 forskellige typer ekstra-tilkøb: -->
        <!-- -Standard "simpelt" ekstra-tilkøb, gælder for hele bookingen, der vælges kun antal -->
        <!-- -Morgenmads tilkøb samme som ovenstående, men med en "hjælper" til at finde korrekt antal, så der vælges personer og antal nætter -->
        <!-- -Detaljeret ekstra tilkøb - her vælges dato og roomnr for hvert tilkøb -->



        <!-- Standard "simpel" ekstra tilkøb -->
        <div class="roomBox" :class='ekstra.ikon' v-if="handleKarens(ekstra.karens) && ekstra.kortnavn != 'Morg2' && ekstra.mode === 'oprindelig'">
          <p class="heading">{{ ekstra.overskrift }}</p>
          <p class="descText">{{ekstra.tekst}}</p>
          <!-- Hvis der er foretaget et valg, så vis prisen -->
          <p v-if="getOrderedEkstras($store.getters.bookingInProgress, ekstra.id_rec) > 0" class="priceText">{{ $t('pris')}}: {{getOrderedEkstras($store.getters.bookingInProgress, ekstra.id_rec) * ekstra.pris}}</p>
          <p v-else class="priceText" style="visibility: hidden;">Pris:</p> <!-- Sæt til hidden hvis pris ikke skal vises, ellers hopper teksten når prisen vises -->
          
          <div class="flex-container">
              <!-- Hvis "antal" er 0 så gør minus-knappen grå - den har ingen effekt -->
              <span v-if="getOrderedEkstras($store.getters.bookingInProgress, ekstra.id_rec) == 0">
            <div id="minus" class="grey"></div>
              </span>
            <span v-else>
                <div id="minus" v-on:click="minusEkstraToOrder($store.getters.bookingInProgress, ekstra)"></div>
            </span>
            <!-- Vis antal valgte ekstra tilkøb -->
            <p class="availability">{{ getOrderedEkstras($store.getters.bookingInProgress, ekstra.id_rec) }}</p>

            <div id="plus" v-on:click="addEkstraToOrder($store.getters.bookingInProgress, ekstra)"></div>
          </div>
          
        </div>

        <!-- Hvis kortnavn er Morg2 skal den behandles specielt, da vi vil vise valg af morgenmad baseret på antal gæster og antal værelser -->
        <div class="roomBox ekstra-madpakke-morgenmad" v-if="handleKarens(ekstra.karens) && ekstra.kortnavn == 'Morg2'">
          <p class="heading">{{ ekstra.overskrift }}</p>
          <p class="descText">{{ekstra.tekst}}</p>
          <p v-if="getOrderedEkstras($store.getters.bookingInProgress, ekstra.id_rec) > 0" class="priceTextMorgenmad">{{ $t('pris')}}: {{getOrderedEkstras($store.getters.bookingInProgress, ekstra.id_rec) * ekstra.pris}}</p>
          <p v-else class="priceTextMorgenmad" style="visibility: hidden;">Pris:</p>

          <!-- Morgenmads tilkøb -->
          <table>
            <tr>
              <td>
                <label for="antal_gaester">{{ $t('personer') }}</label>
              </td>
              <td>
                <select name="" id="antal_gaester" style="width: 35px;" v-model="antal_gaester" @change="setActiveEkstraObject(ekstra)">
                  <option v-for="gaest in antal_gaester_select" v-bind:key="gaest">{{ gaest }}</option>
                </select>
              </td>
              <td>
                <label for="antal_naetter">{{ $t('naetter') }}</label>
              </td>
              <td>
                <select name="" id="antal_naetter" style="width: 35px;" v-model="antal_naetter">
                  <option v-for="nat in antal_naetter_select" v-bind:key="nat">{{ nat }}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <label for="total_morgenmad">{{ $t('totalmorgenmad') }}</label>
              </td>
              <td>
                <input id="total_morgenmad" type="number" size="1" min="0" max="100" style="width: 30px;" v-model="total_morgenmad" @change="setActiveEkstraObject(ekstra)">
              </td>
            </tr>
          </table>

        </div>


<div v-if="false">
        <!-- Ny mere detaljeret ekstra-tilkøbs vælger -->
        <div class="roomBoxNew" :class='ekstra.ikon' v-if="handleKarens(ekstra.karens) && ekstra.mode === 'detaljeret' && !isExcluded(ekstra.ekskluder, $store.getters.bookingInProgress.wants)">
          <p class="heading">{{ ekstra.overskrift }}</p>
          <p class="descText">{{ekstra.tekst}}</p>
          <p v-if="totalPrice(ekstra.id_rec) > 0" class="priceTextMorgenmad" style="padding-bottom: 20px;">{{ $t('pris') }}: {{ totalPrice(ekstra.id_rec) }}</p>
          <p v-else class="priceTextMorgenmad" style="visibility: hidden; padding-bottom: 20px;">&nbsp;</p>


            <div v-for="roomWants in $store.getters.bookingInProgress.wants" v-bind:key="roomWants">
              <div v-for="(detailed, key, i) in detailedEkstras[ekstra.id_rec]" v-bind:key="i">
                <!-- Vis kun noget hvis det er en detailed ekstra, og indholdet gælder for 'room', og det ikke er sat til ekskluderet -->
                <div v-if="detailed && detailed.room == roomWants">
                  <div class="ekstraDetailedBox">
                    <!-- <p>Detailed: {{ detailed }}</p> -->
                    <!-- <p>Ekskluder: {{ ekstra.ekskluder }}</p> -->
                    <!-- <p>Editmode: {{ editMode[ekstra.id_rec][room] }}</p> -->
                    <!-- <p>Valgte dage: {{ detailedEkstrasOriginal[ekstra.id_rec][room].days }}</p> -->
                    <!-- <p v-if=" ekstra.ekskluder.split(',').includes(room) ">Dette værelse er ekskluderet</p> -->
                    <!-- <p>Detailed pris: {{ detailed.pris }}</p> -->
                    <!-- <p>Detailed antal personer: {{ detailed.antal_personer }}</p> -->
                    <!-- <p>Detailed antal nætter: {{ detailed.antal_naetter }}</p> -->
                    <!-- <p>maxTotal: {{ ekstra.maxTotal }}</p> -->
                    
                    <p v-if="detailed">{{$t('vaerelse')}}: {{ roomWants }}</p>
                    <div class="ekstraDetailedName">
                      <input type="checkbox" v-model="detailed.checked" @change="modifyDetailedEkstra(detailedEkstras, ekstra.id_rec, detailed.room, detailed.antal_personer, $store.getters.bookingInProgress.startdate, $store.getters.bookingInProgress.enddate)"><label for="morgenmad">{{ ekstra.kortnavn }}</label>
                    </div>
                    <div class="ekstraDetailedDetails">
                      <p class="ekstraDetailedDetailsPrice">DKK {{ detailed.pris*(detailed.antal_personer * detailed.antal_naetter) }}</p>
                      
                      <!-- vis antal gæster i antal nætter, standard-mode -->
                      <div v-if="editMode[ekstra.id_rec][roomWants] == false">
                        <p>{{ detailed.antal_personer }} {{ ekstra.overskrift }}, {{detailed.antal_naetter}} {{ $t('naetter') }}
                        <span v-if="ekstra.maxTotal == 0" v-on:click="$set(editMode[ekstra.id_rec], roomWants, true)" style="cursor: pointer; text-decoration: underline;">({{ $t('ret') }})</span></p>
                      </div>

                      <!-- vis edit-mode, så der kan vælges antal/nætter -->
                      <div v-if="editMode[ekstra.id_rec][roomWants] == true">
                                                
                          <!-- Antal personer -->
                          <select v-model="detailed.antal_personer">
                            <option v-for="n in detailedEkstras[ekstra.id_rec][roomWants].antal_personer_max" v-bind:key="n">{{ n }}</option>
                          </select> 

                          <span v-if="detailed.antal_personer == 1">{{ $t('person') }}</span><span v-else>{{ $t('personer') }}</span>,

                          <!-- Antal nætter -->
                          <div v-for="day in detailedEkstras[ekstra.id_rec][roomWants].days" v-bind:key="day.date">
                            <input v-model="day.checked" type="checkbox" id="dateEdit" @change="handleAntalNaetterChange(ekstra.id_rec, roomWants); handleDetailedEkstrasChange(detailedEkstras)"><label for="dateEdit">{{ day.date }}</label>
                          </div>

                          <span v-on:click="$set(editMode[ekstra.id_rec], roomWants, false)" style="cursor: pointer; text-decoration: underline; line-height: 12px;">{{ $t('faerdig') }}</span>
                      </div> <!-- end edit-mode -->
                    </div>
                  </div>
                </div>
              </div>
            </div> <!-- end for hvert room -->
        </div> <!-- end detailed-ekstra-tilkøb -->
</div>



      </div> <!-- end for hvert ekstra-tilkøb -->




      <!-- 
        Rettes torsdag 16 juni: 
        Komponenten afhænger af prop'en 'rooms' - denne skal være en liste over værelser gæsten bestiller, og derfor skal have vist en liste af ekstra-tilkøb for
        Den nuværende implementation forventer et objekt for hvert room, ekstra-tilkøbs siden giver dog kun et array af room-no
        Komponenten skal derfor laves om til at acceptere et array af room-no, og det skal vi også lave til efter-tilkøbs siden

        Enten skal begge dele kunne angives som prop, og vi vælger så den rigtige, eller også skal der undersøges om det er et object eller et array der er angivet,
        og transformere om til et array af numre.

        Fjern prop "rooms", og lad komponenten hente listen af rooms fra $store.getters.tb_rooms istedet. Lav en ny prop der hedder 'wants' som vi ret nemt
        kan generere på morgenmad-2.vue til dennes brug.
        -->
<!-- <detailedExtras @detailedEkstrasHasFinishedWritingToVuex="updateChildProgress" :postnr="$store.getters.bookingInProgress.hotel" :roomtype="$store.getters.bookingInProgress.roomtype" cart="addToCart" :startdate="$store.getters.bookingInProgress.startdate" :enddate="$store.getters.bookingInProgress.enddate" :rooms="$store.getters.tb_rooms" :wants="$store.getters.bookingInProgress.wants"></detailedExtras> -->
<detailedExtras @detailedEkstrasHasFinishedWritingToVuex="updateChildProgress" :postnr="$store.getters.bookingInProgress.hotel" :roomtype="$store.getters.bookingInProgress.roomtype" cart="addToCart" :startdate="$store.getters.bookingInProgress.startdate" :enddate="$store.getters.bookingInProgress.enddate" :rooms="$store.getters.tb_rooms" :wants="this.buildSplitWants($store.getters.bookingInProgress.wants, $store.getters.bookingInProgress.split)"></detailedExtras>
    </div>


            <div class="buttonContainer">
            <a href="">
                <div class="continueButton" v-on:click="navigateBack()">
                    <!-- <a>{{ $t('videre')}}</a> -->
                    <a>&laquo; {{$t('tilbage')}} </a>
                </div>
            </a>

            <!-- <router-link to="oplysninger"> -->
            <router-link to="opsummering" v-on:click="navigateForward()">
                <div class="continueButton" v-on:click="navigateForward()">
                  <a>{{ $t('videre')}} &raquo;</a>
                </div>
            </router-link>
        </div>


  </div>
</template>

<script>
//import router from "vue-router";
import i18n from "@/plugins/i18n";
import detailedExtras from "@/components/detailedExtras.vue";
var moment = require('moment');

export default {
  components: {
    detailedExtras
  },
  name: "App",
  data() {
    return {
      visSimpel: 1,
      editMode: [],
      antal_naetter_static: 0,
      active_ekstra_object: {},
      antal_senge: [],
      antal_gaester: 0,
      antal_gaester_select: [],
      antal_naetter: 0,
      antal_naetter_select: [],
      total_morgenmad: 0,
      antal_gaester_per_room: {},
      detailedEkstras: [],             // lokal kopi af alle detaljerede ekstra tilkøb der er til rådighed
      //detailedEkstrasOriginal: [],     // lokal kopi af detaljerede ekstra tilkøb der er ved at blive bestilt
      detailedEkstrasHasFinishedWritingToVuex: false, // Detect om detailedEkstras child komponenten er færdig med at skrive til Vuex
      redirect: false,  // flag der afgører om vi skal redirecte til opsummering - bruges i created() hvis der ikke er nogen ekstras at vælge
    };
  },
  created() {
    this.antal_senge = this.getRoomData().then( () => {
      this.antal_naetter_select = this.makeSelectList(this.antalDage);  // Lav select listen til antal nætter
      this.antal_naetter = Math.max.apply(Math, this.antal_naetter_select); // Lad antal nætter defaulte til max antal i bestillingen
      this.antal_naetter_static = this.antal_naetter; // Sæt antal_naetter_static til valgte antal overnatninger, som vi ikke overskriver
      console.log('Henter ekstras med type: '+this.$store.getters.bookingInProgress.roomtype);

      // Hent ekstra tilkøb fra API ved page load og...
      // Nulstil alle valg der foretages længere fremme i ordreprocessen, så der ikke ligger
      // gammel data og driller, hvis brugeren har trykket tilbage
      this.$store.dispatch("getEkstras", {
        'koncern': this.$route.params.koncern,
        'hotel': this.$store.getters.bookingInProgress.hotel,
        'la': i18n.locale,
        'type': this.$store.getters.bookingInProgress.roomtype
      }).then(() => {
        // Når vi har loadet 'ekstras' så nulstilles ekstras og brugeren videresendes hvis der ikke er nogen ekstra tilkøb tilgængelig
        this.nulstil(this.$store.getters.ekstras);

        // byg this.detailedEkstras - afhænger af this.antal_senge og this.$store.getters.ekstras
        this.buildDetailedEkstras(this.$store.getters.ekstras)

        if(typeof this.$store.getters.ekstras !== 'undefined' && this.countEkstras() <= 0) {
          // Viderestil til opsummering - inden der viderestilles skal detailedEkstras trimmes...
          // Bemærk - denne videresender hvis der ikke en nogen ekstras tilgængelige - den tæller ikke detailedEkstras
          this.redirect = true;

            /**
             * Her forsøger vi at nulstille detailedEkstras, hvis der ikke er nogen ekstra tilkøb til rådighed, som f.eks. ved parkering som værelsestype.
             * Det virker ikke, da child komponenten 'detailedEkstras' også skriver i detailedEkstras - det kører asynkront, så når vi har nulstillet den
             * her, bliver den overskrevet i child komponenten, da den er senere færdig.
             * Vi løser det ved at lade child komponenten sende en besked til os når den er færdig med at skrive, først derefter nulstiller vi og
             * redirecter i routeren til næste side.
             * Vi kan detecte det i child komponenten, og sende videre med parent/child comms i et event.
             * Hvordan detecter vi her at child komponenten har opdateret, så vi kan gå videre? en watcher? 
             * I så fald skal watcheren have en funktion at køre - vi kører jo dette chained efter 'getEkstras'-dispatcheren - men er det nødvendigt?
             * Kunne vi ikke køre det selvstændigt efterfølgende - detecte om der er tilgængelige ekstras - efter ekstras er loaded ?
             * Men så skal vi vel også have en watcher på ekstras ?
             * 
             * I morgen 13 dec - få parent/child comms til at virke - check korrekt syntakts i <detailedEkstras> kaldet i 6-ekstra.vue
             * Check at detailedEkstrasHasFinishedWritingToVuex opdaterer på 6-ekstra
             */

            //this.detailedEkstras = {};
            //this.$router.replace({path: 'opsummering'});
            //this.$router.push({path: 'opsummering'});
        }

        // Sæt aktivt ekstra object til morgenmadsbestilling
        this.active_ekstra_object = this.findEkstraObject(this.$store.getters.ekstras, "Morg2");

      });


    });


    if(this.$store.getters.bookingInProgress.roomtype === 'moedelokale') {
      // Der er ingen "ekstra" i Rønne, derfor bliver brugeren sendt "frem" igen ved tryk på "tilbage" ved "mødelokale", så vi angiver istedet hvilken side brugeren skal sendes tilbage til
      this.$store.dispatch("back", `vaerelsestype/${this.$store.getters.bookingInProgress.roomtype}/hotel/${this.$store.getters.bookingInProgress.hotel}/checkin/${this.$store.getters.bookingInProgress.startdate}/checkout/${this.$store.getters.bookingInProgress.enddate}`); // Gem url på forrige side i Vuex, så vi ved hvilken side vi skal navigere til på 'tilbage'-knappen
    }


    this.buildSplitWants(this.$store.getters.bookingInProgress.wants, this.$store.getters.bookingInProgress.split);
 
  },
  watch: {
    antal_gaester: function () {
      this.total_morgenmad = this.antal_gaester * this.antal_naetter;
    },
    antal_naetter: function () {
      this.total_morgenmad = this.antal_gaester * this.antal_naetter;
    },
    '$store.getters.tb_rooms': function () {
      // Lav select listen til antal gæster (afhænger af at både antal_senge[] og tb_rooms er loadede)
      if(this.antal_senge.length > 0) {
        this.antal_gaester_select = this.makeSelectList(this.totalSengeThisOrder());
      }
    },
    
    detailedEkstrasHasFinishedWritingToVuex: function () {
      // Denne watcher reagerer når this.detailedEkstrasHasFinishedWritingToVuex ændrer indhold - hvis den er 'true' er 'detailedEkstras'-componenten færdig med 
      // at skrive til Vuex store og vi kan derfor skrive til den uden at den bliver overskrevet.
      // Når vi har skrevet redirecter vi til opsummeringssiden
      if(this.detailedEkstrasHasFinishedWritingToVuex === true && this.redirect === true) {
        var name = 'detailedEkstras'
        var value = '';

        this.$store.dispatch("addToCart", {name, value})
        this.$router.push({path: 'opsummering'});
      }
    },
    

    '$store.getters.ekstras': function () {
      if(typeof this.$store.getters.ekstras !== 'undefined' && this.countEkstras() <= 0) {
        // eslint-disable-next-line
        var name = 'detailedEkstras'
        // eslint-disable-next-line
        var value = '';
      }

    },
    antal_senge: function () {
      // Lav select listen til antal gæster (afhænger af at både antal_senge[] og tb_rooms er loadede)
      if(this.$store.getters.tb_rooms.length > 0) {
        this.antal_gaester_select = this.makeSelectList(this.totalSengeThisOrder());
      }
      // detailedEkstras skal bruge antal_senge til at sætte default antal til ekstra tilkøb
      if(this.$store.getters.ekstras.length > 0) {
        this.buildDetailedEkstras(this.$store.getters.ekstras)
      }
    },
    // Skriver ekstra tilkøbet af morgenmad hvis total_morgenmad ændres
    total_morgenmad: function () {
      this.modifyEkstraMorgenmad(this.$store.getters.bookingInProgress, this.active_ekstra_object, this.total_morgenmad);
    },
  },
  computed: {
    // Beregner antal nætter der overnattes
    antalDage: function () {
      var start = new moment(this.$store.getters.bookingInProgress.startdate);
      var end = new moment(this.$store.getters.bookingInProgress.enddate);
      return moment.duration(end.diff(start)).asDays()
    },
  },
  methods: {
    buildSplitWants(wants, split) {
      const wantsValues = [];

      Object.keys(split).forEach(key => {
        split[key].forEach(array => {
          array.forEach(item => {
            wantsValues.push(item.room);
          });
        });
      });

      wants.forEach(want => {
        wantsValues.push(want);
      })
      
      console.log('-buildSplitWants: '+JSON.stringify(wants)+' => '+JSON.stringify(wantsValues));
      return wantsValues;
    },
    // Hent 'detailedEkstrasHasFinishedWritingToVuex' fra detailedEkstras child component, så vi kan detecte at den er færdig med at skrive til vuex
    updateChildProgress(msg) {
      this.detailedEkstrasHasFinishedWritingToVuex = msg;
    },
    /**
     * Returns true if 'wants' is not in 'excluded'
     * @param {string} excluded 
     * @param {int} wants 
     */
    isExcluded(excluded, wants) {
      console.log('Result: '+excluded.split(',').includes(wants.toString()));
      //console.log('Length: '+excluded.split(',').includes(wants)).length;
      console.log('is '+wants+' excluded from: '+excluded);
      console.log(excluded);
/*
      var testExcluded = '30,34,35,55'
      var testWants = 34

      console.log('TestResult: '+testExcluded.split(',').includes(testWants.toString()))
*/

      if(excluded.split(',').includes(wants.toString())) {
        return true
      } else {
        return false
      }
      
     //return true;

    },
    // Beregner totalprisen af valgte ekstra tilkøb
    totalPrice(ekstraId) {
      // Gemmer sum for hvert room
      var totalPrice = [];

      // Gå igennem tilkøb for hvert room og summér for hver valgt dato
      if(this.detailedEkstras[ekstraId] && this.detailedEkstras[ekstraId].length > 0) {
        this.detailedEkstras[ekstraId].forEach(ekstra => {
          if(ekstra !== null) {
            if(ekstra.checked == true) {  // Room er checked
              totalPrice[ekstra.room] = 0;
              console.log('totalPrice ekstra.days: '+JSON.stringify(ekstra.days));
              // Hvis der kun er 1 dato i ekstra.days indeholder den kun det ene objekt, er der flere er det et array af objekter
              if(ekstra.days.length > 0) {
                ekstra.days.forEach(day => {
                  if(day !== null && day.checked == true) {
                    // dato er checked - så den skal tælles med
                    totalPrice[ekstra.room] += parseFloat(ekstra.pris);  // Læg priserne sammen for alle valgte dage - ekstra.pris er en string så den skal parses som en float
                  }
                })
              } else {
                  if(ekstra.days.date !== null && ekstra.days.checked == true) {
                    // dato er checked - så den skal tælles med
                    totalPrice[ekstra.room] += parseFloat(ekstra.pris);  // Læg priserne sammen for alle valgte dage - ekstra.pris er en string så den skal parses som en float
                  }
              }

              //console.log('Ekstra ID: '+ekstraId+' room: '+ekstra.room+' total price: '+totalPrice+' antal personer: '+ekstra.antal_personer);
              totalPrice[ekstra.room] = totalPrice[ekstra.room] * ekstra.antal_personer;  // Prisen ganges til sidst med valgte antal personer
            }
          }
        });
      }

      // Her tages totalprisen for hvert room og lægges sammen
      var sum = 0;
      totalPrice.forEach(price => {
        if(price !== null) {
          sum = sum+price;
        }
      })
    
    return sum;
    },

    // Justerer 'antal_naetter' i 'detailedEkstra' efter hvad der er checked af i detailedEkstras[ekstraId][room].days
    handleAntalNaetterChange(ekstraId,room) {
      var i = 0;
      this.detailedEkstras[ekstraId][room].days.forEach(day => {
        if(day.checked === true) {
          i++;
        }
        
      })
      this.detailedEkstras[ekstraId][room].antal_naetter = i;
      return i;
    },
    // bygger this.detailedEkstras og this.editMode
    buildDetailedEkstras(ekstras) {
      // Først skal arrayet initialiseres - bemærk - vi er nødt til at initialisere ved at bruge 'this.$set'-kald istedet for at modificere 'this.detailedEkstras' 
      // direkte, da Vue ellers ikke kan finde ud af at gøre detailedEkstras reaktiv
      //console.log('Bygger detailedEkstras med disse input data: '+JSON.stringify(ekstras));
      ekstras.forEach(ekstra => {
        if(this.handleKarens(ekstra.karens) && ekstra.mode === 'detaljeret') {
          console.log('Ekstra ID: '+ekstra.id_rec+' Ekstra Navn: '+ekstra.overskrift+' Tekst: '+ekstra.tekst+' Pris: '+ekstra.pris);
          this.$set(this.detailedEkstras, ekstra.id_rec, []);
          this.$set(this.editMode, ekstra.id_rec, []);
          this.$store.getters.bookingInProgress.wants.forEach(room => {
            console.log('room: '+room);
            this.$set(this.detailedEkstras[ekstra.id_rec], room, []);
            this.$set(this.editMode[ekstra.id_rec], room, []);
          });
        }
      });

      // vi skal bruge et array med datoer mellem start og slut
      var dates = this.getDaysRange(this.$store.getters.bookingInProgress.startdate, this.$store.getters.bookingInProgress.enddate);
      dates.forEach(function(part, index, dates) {
        dates[index] = {'date': moment(part).format('YYYY-MM-DD'), 'checked': false}
      });

      // Derefter looper vi igennem igen for at udfylde med data
      ekstras.forEach(ekstra => {
        if(this.handleKarens(ekstra.karens) && ekstra.mode === 'detaljeret') {
          this.$store.getters.bookingInProgress.wants.forEach(room => {

            //this.detailedEkstras[ekstra.id_rec][room] = {'checked': false, 'room': room, 'pris': ekstra.pris, 'antal_personer': this.antal_senge[room], 'antal_naetter': this.antalDage};

            // Her udfyldes detailedEkstras med data
            this.$set(this.editMode[ekstra.id_rec], room, false);

            // Her udfyldes detailedEkstras med data
            this.$set(this.detailedEkstras[ekstra.id_rec], room, {});
            this.$set(this.detailedEkstras[ekstra.id_rec][room], 'checked', false);
            this.$set(this.detailedEkstras[ekstra.id_rec][room], 'room', room);
            this.$set(this.detailedEkstras[ekstra.id_rec][room], 'pris', ekstra.pris);

            // Hvis maxAntal er sat i kontrolpanelet, så sæt antal personer til dette tal, default er antal personer der er plads til på værelset
            if(ekstra.maxAntal > 0 && ekstra.maxAntal > this.antal_senge[room]) {
              console.log('maxAntal: 1, id_rec: '+ekstra.id_rec);
              this.$set(this.detailedEkstras[ekstra.id_rec][room], 'antal_personer', this.antal_senge[room]);
              this.$set(this.detailedEkstras[ekstra.id_rec][room], 'antal_personer_max', this.antal_senge[room]);
            } else if(ekstra.maxAntal > 0 && ekstra.maxAntal <= this.antal_senge[room]) {
              this.$set(this.detailedEkstras[ekstra.id_rec][room], 'antal_personer', ekstra.maxAntal);
              this.$set(this.detailedEkstras[ekstra.id_rec][room], 'antal_personer_max', ekstra.maxAntal);
              console.log('maxAntal: 2, id_rec: '+ekstra.id_rec);
            } else {
              this.$set(this.detailedEkstras[ekstra.id_rec][room], 'antal_personer', this.antal_senge[room]);
              this.$set(this.detailedEkstras[ekstra.id_rec][room], 'antal_personer_max', this.antal_senge[room]);
              console.log('maxAntal: 3, id_rec: '+ekstra.id_rec+' antal senge: '+this.antal_senge[room]);
            }

            this.$set(this.detailedEkstras[ekstra.id_rec][room], 'antal_naetter', this.antalDage);
            this.$set(this.detailedEkstras[ekstra.id_rec][room], 'days', JSON.parse(JSON.stringify(dates)));  // Vi bliver nødt til at sætte 'dates' ind på denne måde, da der ellers bliver indsat referencer til det samme objekt, som derfor ikke kan manipuleres individuelt

            // Hvis maxTotal er sat, sætter vi både antal personer og nætter til 1, og vælger den første nat som dato
            if(ekstra.maxTotal === '1') {
              console.log('maxTotal er 1 på ekstra id: '+ekstra.id_rec);
              this.$set(this.detailedEkstras[ekstra.id_rec][room], 'antal_personer', 1);
              this.$set(this.detailedEkstras[ekstra.id_rec][room], 'antal_personer_max', 1);
              this.$set(this.detailedEkstras[ekstra.id_rec][room], 'antal_naetter', 1);
              this.$set(this.detailedEkstras[ekstra.id_rec][room], 'days', dates[0]);
            }





          });
        }
      });

      console.log('Siden er loaded, og detailedEkstras er seedes med disse data: '+JSON.stringify(this.detailedEkstras));

      // Opret kopi af detailedEkstras, som forbliver uændret
      //this.detailedEkstrasOriginal = JSON.parse(JSON.stringify(this.detailedEkstras));



      // afslut med at skrive ekstras objektet til axios store
      this.handleDetailedEkstrasChange(this.detailedEkstras);

    },
    modifyDetailedEkstra(ekstrasDetailed, ekstraId, room, antal_personer, start, end) {

      // vi skal bruge et array med datoer mellem start og slut
      var dates = this.getDaysRange(start, end);
      dates.forEach(function(part, index, dates) {
        dates[index] = moment(part).format('YYYY-MM-DD')
      });
      
      for (var key in ekstrasDetailed) {
        if (ekstrasDetailed.hasOwnProperty(key)) {
          if (key == ekstraId) {
            // Hvis vi har fundet et ekstraId, og checkboxen er markeret for dette Id, så skriv ændringen
            if(this.detailedEkstras[ekstraId][room].checked == true) {
              ekstrasDetailed[ekstraId][room].checked = true;
            }
          }
        }
      }

      this.handleDetailedEkstrasChange(ekstrasDetailed);

    },
    // Returnerer liste med datoer der ligger imellem start/slut
    getDaysRange(startDate, endDate) {
      var dates = [];

      var currDate = moment(startDate).startOf('day');
      var lastDate = moment(endDate).startOf('day');

      while(currDate.add(1, 'days').diff(lastDate) < 1) {
          //console.log(currDate.toDate());
          dates.push(currDate.clone().toDate());
      }

      return dates;
    },
    // returnerer antal dage imellem to datoer
    findNrOfDays(startDate, endDate) {
      var start = moment(startDate);
      var end = moment(endDate);

      return end.diff(start, 'days');
    },
    // skriver det 'ekstra' objekt som morgenmads tilkøb bruger, så 'total_morgenmad'-watcheren kan få anvist et ekstra-object at skrive tilkøb til
    setActiveEkstraObject(ekstra) {
      this.active_ekstra_object = ekstra;
    },
    // returnerer det ekstra objekt der indeholder det angivne kortnavn
    findEkstraObject(ekstras, kortnavn) {
      for(var i=0; i<ekstras.length; i++) {
        if(ekstras[i].kortnavn == kortnavn) {
          console.log('returnerer ekstras object: '+JSON.stringify(ekstras[i]));
          return ekstras[i];
        }
      }
    },
    // omdanner getteren tb_rooms til nyt array med id_room som key og antal_senge som value så morgenmadsvælgeren kan få max. antal gæster i opholdet
    async getRoomData() {
      console.log('Kører getRoomData()');
      // Hent tb_rooms indhold, bruges til at finde antal gæster der er plads til, til morgenmadsvælgeren
      this.$store.dispatch("getTb_rooms", {'koncern': this.$route.params.koncern, postnr: this.$store.getters.bookingInProgress.hotel}).then(() => {
        //this.rooms = this.$store.getters.tb_rooms;
        const rooms = this.$store.getters.tb_rooms;
        // skriv nyt array
        this.antal_senge = [];
        for(var i=0; i<rooms.length; i++) {
          this.antal_senge[rooms[i]['id_room']] = rooms[i]['antal_senge'];
        }
      });

      return this.antal_senge;
    },
    // Finder totalt antal senge der er valgt, for at sætte max. værdien i select listen til køb af morgenmad
    totalSengeThisOrder() {
      const rooms = this.$store.getters.bookingInProgress.wants;
      var totalSenge = 0;
      rooms.forEach(room => totalSenge = totalSenge + this.antal_senge[room])
      return totalSenge;
    },
    // skriver alle de værdier der skal være i select liste
    makeSelectList(max) {
      let selectList = [];
      for(var i = 1; i <= max; i++) {
        selectList.push(i);
      }

      return selectList;
    },
    modifyEkstraMorgenmad(bookingInProgress, ekstra, value) {
      // overskriver et ekstra tilkøb med nyt antal, bruges til morgenmads tilkøb
      console.log('Kører addEkstraToOrder med value :'+value);
      this.addEkstraToOrder(bookingInProgress, ekstra, value)
    },
    // Nulstiller alle valg der foretages længere fremme i ordreprocessen, så der ikke ligger gammel data
    nulstil(ekstras) {
      var name = 'ekstras';
      var value = {};

      for (var key in ekstras) {
        if(ekstras.hasOwnProperty(key)) {
          // Ekstra køkkenhjælp for selskabslokale bliver sat til '1' som default
          if(ekstras[key].type == 'selskabslokale' && ekstras[key].kortnavn == 'koekkenhjaelp') {
            value[ekstras[key].id_rec] = 1;
          } else {
            value[ekstras[key].id_rec] = 0;
          }
        }
      }
      //console.log('Sætter '+name+': '+JSON.stringify(value) + ' nulstil()');
      this.$store.dispatch("addToCart", {name, value}); // nulstiller ekstras i nulstil()
    },
    countEkstras() {
      var i = 0;
      
      for (var key in this.$store.getters.ekstras) {
        if(this.$store.getters.ekstras.hasOwnProperty(key)) {
          if(this.handleKarens(this.$store.getters.ekstras[key].karens)) {
            i++;
          }

        }
      }
      console.log('ekstras count: '+i);
      return i;
    },
    // vurdér om karens gør at denne ekstra skal vises eller ej
    handleKarens(karens) {
      var start = new moment(this.$store.getters.bookingInProgress.startdate + ' 23:59:59');  // ankomst dagen
      var now = new moment();                                                   // nu
      if(moment.duration(start.diff(now)).asDays() > karens) {                 // hvis forskellen mellem nu og ankomstdagen er mere en der er sat i karens, så vis ekstratilkøbet
        //console.log('ACCEPT: diff:' + moment.duration(start.diff(now)).asDays() + ' karens:'+karens);
        return true;
      } else {
        //console.log('REJECT: diff:' + moment.duration(start.diff(now)).asDays() + ' karens:'+karens);
        return false;
      }

    },
    handleValgtStartDato(startdato) {
      var name = "startdate";
      var value = startdato;
      //console.log("Sætter " + name + ": " + value + ' handleValgtStartDato()');
      this.$store.dispatch("addToCart", { name, value }); // Gem startdato i Vuex store i handleValgtStartDato()
      this.$router.push({ path: "slutdato" }); // Send brugeren videre til næste side
    },
    handleOrderChange(ekstras) {
        // Writes changes to the guests' order to the Vuex store
        var name = 'ekstras';
        var value = ekstras;
        //console.log('Sætter '+name+': '+JSON.stringify(value) + ' handleOrderChange()');
        this.$store.dispatch("addToCart", {name, value});   // gemmer ændring af 'ekstras' i vuex store i handleOrderChange()
    },
    handleDetailedEkstrasChange(detailedEkstras) {
        // Skriver detaljeret ekstra tilkøb til Vuex store
        var name = 'detailedEkstras';
        var value = detailedEkstras;
        //console.log('Sætter '+name+': '+JSON.stringify(value) + ' handleDetailedEkstrasChange()');
        this.$store.dispatch("addToCart", {name, value});   // gemmer ændring af detailedEkstras i vuex store i handleDetailedEkstrasChange()
    },

    /* Returnér antal ekstra tilkøb, af den angivne type, der er bestilt */
    getOrderedEkstras(bookingInProgress, ekstraId) {
      for (var key in bookingInProgress.ekstras) {
        if(bookingInProgress.ekstras.hasOwnProperty(key)) {
          if(key == ekstraId) {
            return bookingInProgress.ekstras[key];
          }
        }
      }
    },
    addEkstraToOrder(bookingInProgress, ekstra, no=-1) {
      var i = 0;
      var found = 0;
      var ekstras = bookingInProgress.ekstras;
      var total = Object.keys(ekstras).length;
      
      for (var key in ekstras) {
        i++;
        if (ekstras.hasOwnProperty(key)) {
          if (key == ekstra.id_rec) {
            if(ekstras[key] < 99999) { // Der er ingen max availability på ekstras (så den er sat til 99999)
              if(typeof ekstras[key] !== 'undefined') {
                // Hvis der er angivet et antal, så brug denne (bruges af morgenmads vælger)
                if(no > -1) {
                  ekstras[key] = no;
                // ellers så inkrementér med 1 (bruges til alle andre ekstra tilkøb)
                } else {
                  ekstras[key]++;
                }
                found++;
              } else {
                ekstras[key] = 1;
                found++;
              }
            } 
          }
        }
      }
      if(i == total && found == 0) {
        ekstras[ekstra.id_rec] = 1;
      }

      this.handleOrderChange(ekstras);
    },
    minusEkstraToOrder(bookingInProgress, ekstra) {
      var i = 0;
      var found = 0;
      var ekstras = bookingInProgress.ekstras;
      var total = Object.keys(ekstras).length;
      
      for (var key in ekstras) {
        i++;
        if (ekstras.hasOwnProperty(key)) {
          if (key == ekstra.id_rec) {
            if(ekstras[key] > 0) { // Der er ingen max availability på ekstras (så den er sat til 99999)
              if(typeof ekstras[key] !== 'undefined') {
                ekstras[key]--;
                found++;
              } else {
                ekstras[key] = 1;
                found++;
              }

            } 
          }
        }
      }
      if(i == total && found == 0) {
        ekstras[ekstra.id_rec] = 1;
      }

      this.handleOrderChange(ekstras);
    },
    navigateBack() {
      if(this.$store.getters.back) {
          console.log('Går tilbage til: '+this.$store.getters.back);
          this.$router.push({ path: this.$store.getters.back });
      } else {
          //this.$router.push({ path: "vaerelsestype" });
          console.log('Går tilbage til 5-vaelgType - roomtype: '+this.$store.getters.bookingInProgress.roomtype+' hotel: '+this.$store.getters.bookingInProgress.hotel+' checkin: '+this.$store.getters.bookingInProgress.startdate+' checkout: '+this.$store.getters.bookingInProgress.enddate);
          //this.$router.push({ name: '5-vaelgType', params: {roomtype: this.$store.getters.bookingInProgress.roomtype, hotel: this.$store.getters.bookingInProgress.hotel, checkin: this.$store.getters.bookingInProgress.startdate, checkout: this.$store.getters.bookingInProgress.enddate} });
          this.$router.push({path: `vaerelsestype/${this.$store.getters.bookingInProgress.roomtype}/hotel/${this.$store.getters.bookingInProgress.hotel}/checkin/${this.$store.getters.bookingInProgress.startdate}/checkout/${this.$store.getters.bookingInProgress.enddate}`}); // Send brugeren videre til næste side
      }
    },
    /**
     * Inden der navigeres frem, køres denne, som bruges til at manipulere i detailedEkstras, for at fjerne ekstras der ikke er valgt. Der er en begrænsning på hvor stort
     * 'continueurl' kan være i QuickPay linket, og med en fuld detailedEkstras, med alle elementer bliver for stor - ekstras der ikke er valgt er ikke relevante efter denne side
     */
    navigateForward() {
      console.log('Justerer detailedEkstras her...');

      // midlertidigt object til at holde de valgte extras
      var croppedExtras = {};
      var i = 0;
      
      // Loop igennem hver extra i booking data
      for (const [ekstraIdKey, ekstraGroup] of Object.entries(this.$store.getters.bookingInProgress.detailedEkstras)) {
        for (const [ekstraId, ekstra] of Object.entries(ekstraGroup)) {
          // Gem kun dem der er checked
          if (ekstra.checked === true) {
            console.log(`Extra checked: ${ekstraIdKey} / ${ekstraId} => ${JSON.stringify(ekstra)}`);

            // Tilføj checked extra til croppedExtras her
            croppedExtras[i] = { [ekstraIdKey]: ekstra };
            i++;
          } else {
            //console.log(`Extra not checked: ${ekstraIdKey} / ${ekstraId}`);
          }
        }
      }

      //console.log('navigateForward(): croppedExtras: '+JSON.stringify(croppedExtras));
      
      // skriv 'croppedExtras' til Axios store
      this.handleDetailedEkstrasChange(croppedExtras)
    },
  }
};
</script>

<style scoped>

h1 {
  font-size: 400%;
  margin-bottom: 120px;
}
.flex-container {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}
.roomBox {
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 348px;
  height: 330px;
  box-sizing: border-box;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 100px;
  margin-top: 100px;
  margin-left: 20px;
  margin-right: 20px;
}
.roomBoxMorgenmad {
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 348px;
  height: 360px;
  box-sizing: border-box;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 100px;
  margin-top: 100px;
  margin-left: 20px;
  margin-right: 20px;
}
.roomBoxNew {
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 348px;
  box-sizing: border-box;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 100px;
  margin-top: 100px;
  margin-left: 20px;
  margin-right: 20px;
}
.heading {
  font-size: 220%;
  margin-bottom: 0px;
  margin-top: -75px;
  height: 40px;
  text-overflow: ellipsis;
}
.descText {
  font-size: 120%;
  margin-top: 0px;
  height: 20px;
  text-transform: none;
}
.priceText {
  font-size: 150%;
  margin-top: 90px;
  margin-bottom: 0px;
  margin-left: 30px;
  margin-right: 30px;
  text-transform: none;
  font-weight: bold;
}
.priceTextMorgenmad {
  font-size: 150%;
  margin-top: 60px;
  margin-bottom: 0px;
  margin-left: 30px;
  margin-right: 30px;
  text-transform: none;
  font-weight: bold;
}
.plusminus {
  padding: 0;
  
  position: relative;
  display: inline;
}

/* Detaljeret ekstra-tilkøb Box-pr-værelseskategori */
.ekstraDetailedBox {
  background: rgba(0,64,114, 0.15); 
  padding-bottom: 5px; 
  padding-top: 1px; 
  padding-right: 5px; 
  margin-bottom: 15px;
  width: 315px;
}

/* Detaljeret ekstra-tilkøb Navn/titel på ekstratilkøb */
.ekstraDetailedName {
  text-align: center; 
  transform: scale(1.5);
}

/* Detaljeret ekstra-tilkøb sektion med prisdetaljer */
.ekstraDetailedDetails {
  text-align: right; 
  font-size: 75%; 
  line-height: 25%;
}

/* Detaljeret ekstra-tilkøb sektion med prisdetaljer, selve prisen */
.ekstraDetailedDetailsPrice {
  font-size: 150%;
}

/* Catch-all, som angiver default ikon hvis vi viser en værelsestype vi ikke har en CSS for */

/* [class^='ekstra']:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_default.png") !important;
  transform: scale(.5) !important;
  margin-top: -150px !important;
  display: block !important;
} */
.ekstra-default:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_default.png");
  transform: scale(.5);
  margin-top: -150px;
  display: block;
}
.ekstra-brev:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_brev.png");
  transform: scale(.5);
  margin-top: -120px;
  display: block;
}
.ekstra-roedvin:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_roedvin.png");
  transform: scale(.5);
  margin-top: -120px;
  display: block;
}
.ekstra-barneseng:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_barneseng.png");
  transform: scale(.5);
  margin-top: -120px;
  display: block;
}
.ekstra-seng:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_seng.png");
  transform: scale(.5);
  margin-top: -150px;
  display: block;
}
.ekstra-madpakke:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_madpakke.png");
  transform: scale(.5);
  margin-top: -120px;
  display: block;
}
.ekstra-madpakke-morgenmad:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_madpakke.png");
  transform: scale(.5);
  margin-top: -153px;
  display: block;
}
.ekstra-morgenmad:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_morgenmad.png");
  transform: scale(.5);
  margin-top: -120px;
  display: block;
}
.ekstra-koekkenhjaelp:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_koekken.png");
  transform: scale(.5);
  margin-top: -120px;
  display: block;
}
.ekstra-vandretur:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_vandretur.png");
  transform: scale(.5);
  margin-top: -120px;
  display: block;
}

/* CSS specific to iOS devices */ 
@supports (-webkit-touch-callout: none) {
  .plusminus {
    /* position: relative;     */
    
  }

}


:before {
  --url: url("../assets/fireseng-ikon.gif");
}

.room-1:before {
  content: url("../assets/enkeltseng-ikon.gif");
  transform: scale(0.5);
  margin-top: -120px;
  display: block;
  position:absolute;
}

.availability {
  font-size: 250%;
  margin-top: -3px;
  margin-left: 30px;
  margin-right: 30px;
}

#plus {
  width: 40px;
  height: 40px;
  position: relative;
  border-radius: 50%;
  background: #004072;
  z-index: 2;
}

.grey {
  filter: opacity(20%);
}

#plus:before,
#plus:after {
  content: "";
  position: absolute;
  z-index: 1;
  background: white;
  border-radius: 50px;
}

#plus:before {
  left: 50%;
  width: 15%;
  margin-left: -7%;
  margin-top: 10%;
  height: 80%;
}

#plus:after {
  top: 50%;
  height: 15%;
  margin-top: -7%;
  margin-left: -40%;
  align-items: center;
  width: 80%;
}

#minus {
  width: 40px;
  height: 40px;
  position: relative;
  border-radius: 50%;
  background: #004072;
  z-index: 2;
}

#minus:after {
  content: "";
  position: absolute;
  z-index: 1;
  background: white;
  border-radius: 50px;
}

#minus:after {
  top: 50%;
  height: 15%;
  margin-top: -7%;
  margin-left: -40%;
  align-items: center;
  width: 80%;
}


.buttonContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 50px;
}

.continueButton {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 280px;
  height: 80px;  
  font-size: 150%;
  letter-spacing: 1px;
  padding-left: 10px;
  padding-right: 10px;
  margin: 20px;
  white-space: nowrap;
  flex: 0 0 100%;
}

a {
  text-decoration: none;
  color: black;
  text-align: center;
  line-height: 80px;
}

/* når viewport er mindre end 960 px */
@media (max-width: 959px) {
  /* Mindre overskrift */
  h1 {
    font-size: 200%;
    margin-bottom: 50px;
  }

  /* Ekstra-box ved smal vindue */
  .roomBox {
    margin-top: 20px;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 40px;
    transform: scale(.8);
  }

  /* Ekstra-box ved smal vindue */
  .roomBoxNew {
    margin-top: 20px;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 40px;
    transform: scale(.8);
  }

  /* "Videre"-knappen centreres */
  .continueButton {
  float: none;
  display: inline-block;
  }

}

</style>
